import cn from 'classnames';
import type { InputHTMLAttributes, ReactNode } from 'react';

import { ErrorInput } from './ErrorInput/ErrorInput';

import styles from './Input.module.scss';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  [x: string]: any;
  button?: ReactNode;
  children?: ReactNode;
  emptyError?: boolean;
  name?: string;
  placeholder?: any;
  type?: string;
}

export const Input = ({
  register,
  name,
  rules,
  size,
  button,
  type,
  errors,
  emptyError,
  values,
  ...props
}: InputProps): JSX.Element => (
  <div className={styles.wrapper}>
    <input
      {...props}
      name={name}
      onWheel={(e: React.ChangeEvent<HTMLInputElement>) => e.target.blur()}
      {...(register && rules && register(name, rules))}
      style={props?.style && props.style}
      type={type}
      className={cn(
        styles.input,
        props?.className && props.className,
        size && styles.size,
        errors && styles.invalid,
        !errors && values && styles.valid,
        type === 'password' && styles.password,
      )}
    />
    {button && <div className={styles.button}>{button}</div>}
    {errors && !emptyError && <ErrorInput>{errors}</ErrorInput>}
  </div>
);
